import { Component, EventEmitter, Inject, Output, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { platform } from '../../../../platform/platform';
import { NetworkStatusService } from '../../../_services/network-status.service';
import { BROWSER_TYPE, PLATFORM } from '../../../app.constants';
import { UtilsService } from '../../../_services/_utils.service';
import { UploadProgressDialogService } from './upload-progress-dialog.service';
@Component({
    selector: 'app-upload-progress-dialog',
    templateUrl: './upload-progress-dialog.component.html',
    styleUrls: ['./upload-progress-dialog.component.scss'],
    standalone: false
})
export class UploadProgressDialogComponent implements OnDestroy {

  /** ダイアログの width のデフォルト値。 */
  public static readonly defaultDialogWidth: string = '600px';
  /** ダイアログの maxHeight のデフォルト値。 */
  public static readonly defaultDialogMaxHeight: string = '540px';
  /** ダイアログの minHeight のデフォルト値。 */
  public static readonly defaultDialogMinHeight: string = '385px';

  readonly kbLimit = 1024;

  isTransfer = false;
  get completeFileCount() {
    return this.uploadProgressDialogService.completeFileCount;
  }
  get successFileCount() {
    return this.uploadProgressDialogService.successFileCount;
  }
  get totalFileCount() {
    return this.uploadProgressDialogService.totalFileCount;
  }
  get isDisabledCancel() {
    return this.uploadProgressDialogService.isDisabledCancel;
  }
  get isError() {
    return this.uploadProgressDialogService.isError;
  }
  isFileWrong = false;
  imageFileResultList: { [filePath: string]: string };

  get loadedFileSize() {
    return this.uploadProgressDialogService.loadedFileSize / this.kbLimit;
  }
  get totalFileSize() {
    return this.uploadProgressDialogService.totalFileSize / this.kbLimit;
  }
  get transferStartTime() {
    return this.uploadProgressDialogService.transferStartTime;
  }
  get progressMode() {
    return this.uploadProgressDialogService.progressMode;
  }

  get isSaveStart() {
    return this.uploadProgressDialogService.isSaveStart;
  }

  @Output() dialogClose = new EventEmitter();
  constructor(
    public dialogRef: MatDialogRef<UploadProgressDialogComponent>,
    private utilsService: UtilsService,
    private networkStatusService: NetworkStatusService,
    private uploadProgressDialogService: UploadProgressDialogService,
    @Inject(MAT_DIALOG_DATA) public data: { isTransfer: boolean, inBackground: boolean }
  ) {
    if (data?.inBackground) {
       document.body.classList.add('hide-overlay');
    }

    if (data?.hasOwnProperty('isTransfer')) {
      this.isTransfer = data.isTransfer;
    }
  }

  ngOnDestroy() {
    document.body.classList.remove('hide-overlay');
  }

  get isDesktop() {
    return this.networkStatusService.isDesktop();
  }

  get isOffline() {
    return this.networkStatusService.isOffline;
  }

  public get performanceTime() {
    return performance.now();
  }

  public get receivedFileProgress() {
    return Math.floor(this.loadedFileSize / this.totalFileSize * 100);
  }

  public get fileUploadProgress() {
    return this.uploadProgressDialogService.fileUploadProgress;
  }

  public get browserFlag() {
    const browserType = this.utilsService.getBrowserName();
    return browserType === BROWSER_TYPE.EDGE || browserType === BROWSER_TYPE.CHROME;
  }

  public get transferEstimatedSeconds() {
    if (this.receivedFileProgress >= 100) {
      return 0;
    }

    const progressTime = this.performanceTime - this.transferStartTime;
    // 0.5s 未満では処理待ちとする
    if (progressTime < 500 || this.loadedFileSize <= 0) {
      return -1;
    }

    const progressSeconds = Math.ceil(progressTime / 1000);
    const remainingSize = this.totalFileSize - this.loadedFileSize;
    const perLoadFileSize =  this.loadedFileSize / progressSeconds;
    const result = Math.ceil(remainingSize / perLoadFileSize);

    return result;
  }

  public get saveEstimatedSeconds() {
    if (this.fileUploadProgress >= 100) {
      return 0;
    }

    const progressTime = this.performanceTime - this.uploadProgressDialogService.saveStartTime;
    // 0.5s 未満では処理待ちとする
    if (progressTime < 500 || this.completeFileCount <= 0) {
      return -1;
    }

    const progressSeconds = Math.ceil(progressTime / 1000);
    const remainingFileCount = this.totalFileCount - this.completeFileCount;
    const averageProgressSeconds =  progressSeconds / this.completeFileCount;
    const result = Math.ceil(remainingFileCount * averageProgressSeconds);

    return result;
  }

  onClick(): void {
    this.dialogRef.close();
  }
  cancel() {
    this.dialogClose.emit();
  }

}
